
// SVG Icon: dismiss-20
export default { id: "terriajs-dismiss-20" };
export const id = "terriajs-dismiss-20";
export const name = "dismiss-20";
